var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.animatedHeadline'] = (function () {
    'use strict';

    const initialize = (widget) => {

        const carouselEl = widget.querySelector(".splide");
        if (!carouselEl) return;

        const splideOptions = {
            type: "fade",
            //focus: "center",
            rewind: true,
            pagination: false,
            arrows: false,
            noDrag: true,
            interval: 3000,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            resetProgress: false,
            drag: false,
        };

        App.Helpers.splideFallback(
            carouselEl,
            splideOptions,
            (splide) => {
                splideEventBindings(splide, carouselEl, widget);
            }
        );
    };

    const splideEventBindings = (splide, carouselEl, widget) => {

        const controls = widget.querySelector(".animated-headline__controls");
        if (!controls) return;

        splide.on("mounted", () => {

            // arrows
            const nextArrow = controls.querySelector(".animated-headline__next");
            const prevArrow = controls.querySelector(".animated-headline__prev");
            const playButton = controls.querySelector(".animated-headline__play");
            const pauseButton = controls.querySelector(".animated-headline__pause");

            nextArrow?.addEventListener("click", () => splide.go('>'));
            prevArrow?.addEventListener("click", () => splide.go('<'));
            playButton?.addEventListener("click", () => play(splide, controls));
            pauseButton?.addEventListener("click", () => pause(splide, controls));
        });
    };

    const play = (splide, controls) => {
        controls.querySelector(".animated-headline__play").setAttribute("aria-pressed", "true");
        controls.querySelector(".animated-headline__pause").setAttribute("aria-pressed", "false");
        controls.querySelector(".animated-headline__play").classList.add("d-none");
        controls.querySelector(".animated-headline__pause").classList.remove("d-none");
        splide.Components.Autoplay.play();
    };

    const pause = (splide, controls) => {
        controls.querySelector(".animated-headline__play").setAttribute("aria-pressed", "false");
        controls.querySelector(".animated-headline__pause").setAttribute("aria-pressed", "true");
        controls.querySelector(".animated-headline__play").classList.remove("d-none");
        controls.querySelector(".animated-headline__pause").classList.add("d-none");
        splide.Components.Autoplay.pause();
    };

    return {
        initialize
    };

})();